const keyAccessToken = 'access_token'
const keyRefreshToken = 'refresh_token'
const keyUser = 'user'

class StorageBase {
  constructor (prefix) {
    this.prefix = prefix
  }
  key (k) {
    return this.prefix ? this.prefix + '.' : '' + k
  }
  getJSON (k) {
    const v = localStorage.getItem(this.key(k))
    if (!v) return null
    try { return JSON.parse(v) } catch (err) { return null }
  }
  setJSON (k, v) {
    return localStorage.setItem(this.key(k), JSON.stringify(v))
  }
  get accessToken () {
    return localStorage.getItem(keyAccessToken)
  }
  set accessToken (t) {
    localStorage.setItem(keyAccessToken, t)
  }
  get refreshToken () {
    return localStorage.getItem(keyRefreshToken)
  }
  set refreshToken (t) {
    localStorage.setItem(keyRefreshToken, t)
  }
  get user () {
    return this.getJSON(keyUser)
  }
  set user (u) {
    return this.setJSON(keyUser, u)
  }
  clear () {
    localStorage.removeItem(keyAccessToken)
    localStorage.removeItem(keyRefreshToken)
    localStorage.removeItem(keyUser)
  }
}

export default StorageBase
